import { ResourceContact } from '../pagination/ListResourcesPagination'
import Page from '../pagination/Page'

export default class ListResourcesActionPayload {
  page: Page<ResourceContact>

  constructor (page: Page<ResourceContact>) {
    this.page = page
  }
}
